var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"ng-cloak\"><order-details ng-if=\"$ctrl.orderId\" order-id=\"$ctrl.orderId\" openedit=\"$ctrl.openedit\" mode=\"$ctrl.mode\"></order-details><h1 ng-show=\"$ctrl.$cart.isBusy()\" class=\"text-center content\"><i class=\"fa fa-spinner fa-spin fa-5x text-info\"></i></h1></div>";
var id1="order-view.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;